module.exports = __webpack_public_path__ + "static/media/nalgonda.71ddada1.png";